import React, { useState } from "react";
import PlanCard from "../../components/_order_summary/PlanCard/PlanCard";
import leftArrow from "../../assets/leftArrow.svg";
import Layout from "../../shared/Layout/Layout";
import { useNavigate } from "react-router-dom";
import styles from "./OrderSummary.module.scss";
import { checkout } from "../../api/axios";
import Spinner from "../../shared/Spinner/Spinner";

const OrderSummary = () => {
  const navigate = useNavigate();
  const planName = localStorage.getItem("planName");
  const planAmount = localStorage.getItem("planAmount");
  const [loading, setLoading] = useState(false);

  // const handleCheckout = async () => {
  //   setLoading(true);
  //   const payload = {
  //     planName,
  //   };
  //   const response = await checkout(payload);
  //   if (response.data.success) {
  //     window.location.assign(response.data.sessionUrl);
  //   }
  //   setLoading(false);
  // };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div
            className={styles.leftArrow}
            onClick={() => navigate("/subscription-plans")}
          >
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Order Summary</h1>

          <PlanCard planName={planName} planAmount={planAmount} />

          <button
            // onClick={handleCheckout}
            onClick={() => navigate("/payments")}
          >
            {loading ? <Spinner /> : "Proceed to payment"}
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default OrderSummary;
